import { Line,Site } from './line.model'


export default class LineService{

    fetchLines(): Promise<Line[]> {
        return fetch('api/line/lines')
            .then(response => response.json() as Promise<Line[]>);            
    }

    fetchSites(): Promise<Site[]> {
        return fetch('api/site/sites')
            .then(response => response.json() as Promise<Site[]>);            
    }

    /**
     * Posts a line to the server
     * @param line
     */
    postLine(line: Line): Promise<any> {
        return fetch('api/line/addline',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(line)
            })
            .then(response => response.status);
    }

    /**
     * Posts an cell to the server
     * @param line
     */
    updateLine(line: Line): Promise<any> {
        return fetch('api/line/updateline',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(line)
            })
            .then(response => response.status);
    }


    /**
     * Posts an line to the server
     * @param lines
     */
    deleteLines(lines: Line[]): Promise<any> {
        return fetch('api/line/deleteline',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(lines)
            })
            .then(response => response.status);
    }
}